import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Planzone } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  planzones: Identifiable<Planzone>[];
  retrievePlanzones(): void;
}

function usePlanzonesRetrieval(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isPlanzonesRetrievalRequestPending),
    isRequestSuccess: useSelector(selector.isPlanzonesRetrievalRequestSuccess),
    isRequestFailure: useSelector(selector.isPlanzonesRetrievalRequestFailure),
    planzones: useSelector(selector.getPlanzones),
    retrievePlanzones: core.retrievePlanzones,
  };
}

export { usePlanzonesRetrieval };
